import React from "react";
import {
  BitBucketImg,
  FirebasetImg,
  FluttertImg,
  GithubImg,
  GitlabtImg,
  HubspotImg,
  JavaScriptImg,
  JiraImg,
  LaravelImg,
  MongoImg,
  MySQLImg,
  nodeImg,
  PostmanImg,
  reactImg,
  SassImg,
  VisualCodeImg,
  vueImg,
} from "../../assets/img";
import "./TechList.css";

function TechList() {
  return (
    <>
      <section className="tech_wrap spacing">
        <div className="tw-inner container">
          <h4>Technologies which we use.</h4>
          <div className="tech">
            <div className="tech_item">
              <div className="t-img-wrap">
                <img src={SassImg} alt="Sass" />
                Sass
              </div>
              <div className="t-img-wrap">
                <img src={JavaScriptImg} alt="Javascript" />
                Javascript
              </div>
              <div className="t-img-wrap">
                <img src={reactImg} alt="React Js" />
                React Js
              </div>
              <div className="t-img-wrap">
                <img src={vueImg} alt="Vue Js" />
                Vue Js
              </div>

              <div className="t-img-wrap">
                <img src={nodeImg} alt="Node Js" />
                Node Js
              </div>
              <div className="t-img-wrap">
                <img src={MongoImg} alt="Mongo DB" />
                Mongo DB
              </div>
              <div className="t-img-wrap">
                <img src={FirebasetImg} alt="Firebase" />
                Firebase
              </div>
              <div className="t-img-wrap">
                <img src={MySQLImg} alt="MySQL" />
                My-SQL
              </div>
              <div className="t-img-wrap">
                <img src={LaravelImg} alt="Laravel" />
                Laravel
              </div>
              <div className="t-img-wrap">
                <img src={reactImg} alt="React Native" />
                React Native
              </div>
              <div className="t-img-wrap">
                <img src={FluttertImg} alt="FlutterImg" />
                Flutter
              </div>
              <div className="t-img-wrap">
                <img src={HubspotImg} alt="Hubspot" />
                HubSpot CRM
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="tech_wrap spacing">
        <div className="tw-inner container">
          <h4>Tools which we use.</h4>
          <div className="tech">
            <div className="tech_item">
              <div className="t-img-wrap">
                <img src={VisualCodeImg} alt="Visual Code" />
                Visual code
              </div>
              <div className="t-img-wrap">
                <img src={PostmanImg} alt="Postman" />
                Postman
              </div>
              <div className="t-img-wrap">
                <img src={GithubImg} alt="Github" />
                Github
              </div>
              <div className="t-img-wrap">
                <img src={GitlabtImg} alt="Gitlab" />
                Gitlab
              </div>
              <div className="t-img-wrap">
                <img src={BitBucketImg} alt="Bitbucket" />
                Bitbucket
              </div>
              <div className="t-img-wrap">
                <img src={JiraImg} alt="Jira" />
                Jira
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TechList;
